import { useAuthStore } from '@/stores/auth'

import { createWebHashHistory, createRouter } from "vue-router"

import Template from "@/components/Template"
import Login from "@/views/login/Login"
import Managements from "@/views/managements/Managements"
import SearchManagement from "@/views/managements/SearchManagement"
import Generalnformation from "@/views/managements/submenu/Generalnformation"

import FormManagementView from '@/views/managements/submenu/FormManagementView'
import PaymentIntentionView from '@/views/managements/submenu/PaymentIntentionView'
import PDFManagementView from '@/views/managements/submenu/PDFManagementView'
import PaymentHistoryView from '@/views/managements/submenu/PaymentHistoryView'
import AgreementsView from '@/views/managements/submenu/AgreementsView'
import ManagementView from '@/views/managements/submenu/ManagementView'
import TelephoneManagement from '@/views/managements/submenu/TelephoneManagement'
import AddressManagementView from '@/views/managements/submenu/AddressManagementView'
import AddressEndorsementsView from '@/views/managements/submenu/AddressEndorsementsView'

// import AccessUserManagement from "@/views/managements/AccessUserManagement"
import InfoManagementView from "@/views/managements/InfoManagement"
import UserManagement from "@/views/user-management/UserManagement"
import FormUserManagement from "@/views/user-management/FormUserManagement"
import DespachosView from '@/views/despachos/DespachosView.vue'
import Workplaces from "@/views/workplaces/Workplaces"
import ProjectTracking from "@/views/project-tracking/ProjectTracking"
import Setup2FA from "@/views/google2fa/Setup2FA.vue"
import Validate2FA from "@/views/google2fa/Validate2FA.vue"
import EmptyView from "@/views/EmptyView"
import PageNotFound from "@/views/PageNotFound"
import Groups from "@/views/groups/Groups"
import CalendarView from "@/views/calendar/Calendar"
import Notices from "@/views/notices/Notices"
import Minutas from "@/views/minutas/Minutas"
import DatabaseView from "@/views/database/DatabaseView"
import SCLImportView from "@/views/database/SCLImport"
import ImportTrackingView from "@/views/database/ImportTracking"
import ImportDetailView from "@/views/database/ImportDetail"
import ReportsView from "@/views/reports/ReportsView"
import DebtorFieldConfigView from "@/views/reports/DebtorFieldConfigView"
import DocumentView from "@/views/documents/DocumentView"
import CategoryView from "@/views/documents/CategoryView"
import SubcategoryView from "@/views/documents/SubcategoryView"
import Graficas from "@/views/graficasEstaticas/Graficas"
import EstadisticaGestiones from "@/views/graficasEstaticas/EstadisticaGestiones"
import EstadisticaCobranza from "@/views/graficasEstaticas/EstadisticaCobranza"
import EstadisticaMetas from "@/views/graficasEstaticas/EstadisticaMetas.vue"
import MainScreenView from "@/views/main-screen/MainScreenView.vue"
import IsabelleConnection from "@/connections/IsabelleConnection.vue"
import NoticiasView from "@/views/carruselNoticias/Noticias.vue"
import BitacoraView from "@/views/bitacora/Bitacora.vue"

const routes = [
  { path: '/login', component: Login, name: 'Login' },
  { 
    path: '/',
    redirect: '/SGCCV'
  },
  {
    path: '/:catchAll(.*)',
    component: PageNotFound
  },
  { path: '/SGCCV/managementIsabelle/:phone', component: IsabelleConnection },
  { 
    path: '/SGCCV', 
    component: Template, 
    children: [
      { path: '/SGCCV/', component: MainScreenView },
      { name: 'management-search', path: '/SGCCV/management', component: Managements },
      { name: 'management-search-results', path: '/SGCCV/search-management/:form', component: SearchManagement },
      { path: '/SGCCV/access-search-management/:form', component: InfoManagementView,
        children: [
          { name: 'general', path: 'general', component: Generalnformation },
          { name: 'form-management', path: 'form-management', component: FormManagementView },
          { name: 'payment-intention', path: 'payment-intention', component: PaymentIntentionView },
          { name: 'pdf-management', path: 'pdf-management', component: PDFManagementView },
          { name: 'payment-history', path: 'payment-history', component: PaymentHistoryView },
          { name: 'agreements', path: 'agreements', component: AgreementsView },
          { name: 'management', path: 'management', component: ManagementView },
          { name: 'telephone', path: 'telephone', component: TelephoneManagement },
          { name: 'address-management', path: 'address-management', component: AddressManagementView },
          { name: 'address-endorsement', path: 'address-endorsement', component: AddressEndorsementsView },
        ]
      },
      { path: '/SGCCV/user-management', component: UserManagement },
      { path: '/SGCCV/user-management/form/:form', component: FormUserManagement },
      { path: '/SGCCV/workplaces', component: Workplaces },
      { path: '/SGCCV/despachos', component: DespachosView },
      { path: '/SGCCV/calendar', component: CalendarView },
      { path: '/SGCCV/projectTracking', component: ProjectTracking },
      { path: '/SGCCV/empty', component: EmptyView },
      { path: '/SGCCV/groups', component: Groups },
      { path: '/SGCCV/notices', component: Notices },
      { path: '/SGCCV/minutas', component: Minutas },
      { path: '/SGCCV/database', component: DatabaseView },
      { path: '/SGCCV/database/imports/scl', component: SCLImportView },
      { path: '/SGCCV/database/imports', component: ImportTrackingView },
      { path: '/SGCCV/database/imports/:id', component: ImportDetailView },
      { path: '/SGCCV/reports', component: ReportsView },
      { path: '/SGCCV/debtor-fields', component: DebtorFieldConfigView },
      { path: '/SGCCV/documents', component: DocumentView },
      { path: '/SGCCV/documents/category', component: CategoryView },
      { path: '/SGCCV/documents/subcategory', component: SubcategoryView },
      { path: '/SGCCV/graficas', component: Graficas },
      { path: '/SGCCV/estadistica', component: Graficas },
      { path: '/SGCCV/estadistica-gestiones', component: EstadisticaGestiones },
      { path: '/SGCCV/estadistica-cobranza', component: EstadisticaCobranza },
      { path: '/SGCCV/estadistica-metas', component: EstadisticaMetas },
      { path: '/SGCCV/carrusel', component: NoticiasView },
      { path: '/SGCCV/bitacora', component: BitacoraView },
    ]
  },
  {
    path: '/authenticate/2fa',
    children: [
      {
        path: 'setup',
        component: Setup2FA,
        name: 'Setup2FA'
      },
      {
        path: 'validate',
        component: Validate2FA,
        name: 'Validate2FA'
      }
    ],
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})


router.beforeEach((to, from, next) => {
  
  // If trying to access SGCCV routes and 2FA is required but not validated
  if (to.path.startsWith('/SGCCV')) {
    const authStore = useAuthStore();
    if(!authStore.isAuthenticated) {
      return next({ name: 'Login' });
    }
    if (authStore.twoFAStatus === 'REQUIRES_SETUP') {
      return next({ name: 'Setup2FA' });
    } else if (authStore.twoFAStatus === 'SETUP') {
      return next({ name: 'Validate2FA' });
    }
  }

  if (to.path.includes('/SGCCV/managementIsabelle/')) {
    return true
  }

  const TOKEN = localStorage.getItem('TOKEN')
  if (to.path !== '/login' && TOKEN === null || TOKEN === undefined || TOKEN === '') {
    return next({ name: 'Login' });
  }
  next();
})

export default router